module.exports = __webpack_public_path__ + "static/assets/f28ccf0a6640f5b08b49bed8773fbdd2.jpg";